module.exports = __webpack_public_path__ + "media/images/redesign-images/ffa/flatlays/flatlay-06-39132cf07f082e2af8badce6e29ae368.webp";